module.exports = __webpack_public_path__ + "static/media/muskox.c3879650.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Seers/muskox.jpg
// module id = 142
// module chunks = 0